import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  return <section className="py-24 bg-teal-900 text-cream-50" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-181">
            <h2 className="font-serif text-4xl md:text-5xl text-gold-500 mb-6" data-id="element-182">
              The Peri-Belly Protocol
            </h2>
            <p className="text-lg leading-relaxed" style={{
            color: '#FAF5EB'
          }} data-id="element-183">
              No gym. No calorie counting. No complicated rules.
              <br data-id="element-184" />
              <br data-id="element-185" />
              Just a clear daily system you can actually follow.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186">
          {[{
          title: '1: Protein Floor',
          desc: 'A simple daily minimum that makes your appetite quieter and your plan easier to follow. Stops the 9pm snack spiral.',
          icon: '🥩'
        }, {
          title: '2: Step Baseline',
          desc: 'Low-stress movement you can do anywhere — no exhausting cardio.',
          icon: '👣'
        }, {
          title: '3: Strength Anchor',
          desc: '15–20 minute home sessions that help your body stay firm and stop getting softer.',
          icon: '💪'
        }].map((lever, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-teal-800 p-8 rounded-lg border border-teal-700 shadow-xl" data-id="element-187">
              <div className="text-4xl mb-6" data-id="element-188">{lever.icon}</div>
              <h3 className="font-serif text-2xl text-cream-50 mb-4" data-id="element-189">
                {lever.title}
              </h3>
              <p className="text-cream-100 leading-relaxed" data-id="element-190">{lever.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-191">
          <p className="text-xl text-cream-100 max-w-2xl mx-auto" data-id="element-192">
            You'll get the exact plan, the schedule, and the trackers—so you
            always know what to do next.
          </p>
        </motion.div>
      </div>
    </section>;
}